import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { MDash } from 'ui-components/components/mdash/mdash';

import FormattedCurrencyContainer from '../../../components/formatted-currency/container';
import { AU, DE, FR, GB, NZ } from '../../../constants/country-codes';
import Global from '../../../store/global-selectors';
import { CostReviewLine } from '../cost-review-line-item-service/cost-review-line';

export const SERVICE_NAME = {
  VAT: 'VAT',
  GST: 'GST',
};

export const countriesWithVAT = [GB, FR, DE];
export const countriesWithGST = [NZ, AU];

/**
 * @param {object} props
 * @param {number} [props.percentage] - Percentage of charge
 * @param {string} [props.currencyCode] - Currency code to display in cost review
 * @param {number} [props.value] - Amount to display in cost review
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemVAT = ({ percentage = 0, currencyCode, value }) => {
  const intl = useIntl();
  const hidePercentage = value > 0 && percentage === 0;
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const serviceName = useMemo(() => {
    if (countriesWithVAT.includes(sellerHomeCountry)) {
      return SERVICE_NAME.VAT;
    }
    if (countriesWithGST.includes(sellerHomeCountry)) {
      return SERVICE_NAME.GST;
    }
  }, [sellerHomeCountry]);

  if (!serviceName) {
    return null;
  }

  return (
    <CostReviewLine>
      {hidePercentage ? (
        <label>{serviceName}</label>
      ) : (
        <label>{`${serviceName} (${intl.formatNumber(percentage / 100, { style: 'percent', maximumFractionDigits: 0 })})`} </label>
      )}
      {value ? <FormattedCurrencyContainer currencyCode={currencyCode} value={value} /> : <MDash />}
    </CostReviewLine>
  );
};
